import { Tier } from '@sdk/API';
import {
  getPackageByUserID,
  getPackageByTier,
} from '@sdk/managers/PackageManager';

export const DEFAULT_USER_FIELDS = [
  'id',
  'username',
  'firstName',
  'lastName',
  'gender',
  'yearOfBirth',
  'proxyUserID',
  'email',
  'phone',
];

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  gender: string;
  phone?: string;
  username: string;
  yearOfBirth: string;
}

export interface TierPackage {
  id: string;
  tier: string;
  price: string;
  pollOptionLimit: number;
  groupPollAllowed: boolean;
  pledgeAllowed: boolean;
  pledgeChargePercentage: string;
  pollDurationLimit: string;
  pollResultLiveAllowed: boolean;
  statisticReportAllowed: boolean;
  withdrawalAllowed: boolean;
  extensionPledgeAllowed: boolean;
}

export const getUserTierPackage = async (
  _query: string,
  userId: string
): Promise<TierPackage> => {
  return getPackageByUserID(userId);
};

export const getTierPackage = async (
  _query: string,
  tier: Tier
): Promise<TierPackage> => {
  return getPackageByTier(tier);
};
